import axios from 'axios'

// URL base dell'API per le risposte dei sondaggi, recuperato dall'env file
const RISPOSTE_SONDAGGI_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'risposte'

const headers = { 'Content-Type': 'application/json' }

class RisposteSondaggioService {

    /**
     * Restituisce tutte le risposte di un sondaggio specifico
     * @param {number} sonId - ID del sondaggio
     * @returns {Promise}
     */
    getRisposteBySondaggio(sonId) {
        return axios.get(`${RISPOSTE_SONDAGGI_REST_API_URL}/by-sondaggio/${sonId}`, { headers });
    }

}


// Creazione dell'istanza per essere importata direttamente nei componenti
const risposteSondaggioServiceInstance = new RisposteSondaggioService()
export default risposteSondaggioServiceInstance;